import styled from 'styled-components';
import { COLOR_WHITE, COLOR_LIGHTER_GREY, COLOR_GREEN } from '../../assets/styles/colors';
import { BodyTextSC } from '../../components/typography/body-text';

export const ContainerSC = styled.div`
  padding: 70px 0;
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 80px);
  background: ${COLOR_LIGHTER_GREY};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CardSC = styled.div`
  background: ${COLOR_WHITE};
  box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.04);
  padding: 16px 24px;
  width: 100%;
  max-width: 803px;
  min-height: 200p;
  border-radius: 12px;

  .loading-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 60px 0;
  }

  .react-select,
  .react-select-error {
    &__control {
      margin-bottom: 0px !important;
    }
  }

  .success {
    padding: 40px 0;
    text-align: center;
    display: flex;
    flex-direction: column;

    .icon-wrapper {
      margin-bottom: 15px;
    }

    ${BodyTextSC} {
      display: block;
    }

    .check-circle {
      g {
        stroke: ${COLOR_GREEN};
        stroke-opacity: 1;
        stroke-width: 5;
      }
    }

    svg {
      width: 60px;
      height: 60px;
    }

    .redirect-btn {
      margin-top: 20px;
    }

    .last-paragraph {
      margin-top: 10px;
    }
  }
`;

export const CardTopSC = styled.div`
  p {
    display: block;
    text-align: center;
    font-size: 18px;
  }
`;
